export const LeapnAdminList = [
  "0x46F8351307482C162d7267F0fe08d5efd8Ba3BF1"
]